import {
    userBlockedError,
    wrongPartnerError,
} from '../LoginNew/LoginSide/LoginNotifications/index.constants';

const warnNotifications = [userBlockedError, wrongPartnerError];

export const isWarnNotification = (errorType: string) => warnNotifications.includes(errorType);
